import React from 'react';
import './Loader.scss';
import { CircularProgress, makeStyles } from '@material-ui/core';
import classNames from 'classnames';

type LocalLoaderProps = {
    children: React.ReactNode;
    isLoading?: boolean;
    iconSize?: number;
};

const useStyles = makeStyles(() => ({
    wrapper: {
        position: 'relative',
    },

    loader: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

export const LocalLoader: React.FC<LocalLoaderProps> = ({
    children,
    isLoading,
    iconSize,
}) => {
    const classes = useStyles();

    return (
        <div className={classes.wrapper}>
            {children}
            {isLoading && (
                <div
                    className={classNames(
                        'Loader',
                        'Loader--local',
                        classes.loader,
                    )}
                    data-testid="LocalLoader"
                    aria-busy="true"
                    role="status"
                >
                    <CircularProgress size={iconSize ?? 36} />
                </div>
            )}
        </div>
    );
};
